import { buildTrialInfoOrUndefined } from './TrialInfo';
export const buildCurrentUserResponseOrNull = (data) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (!data)
        return null;
    const result = {
        activePlanId: (_a = data.activePlanId) !== null && _a !== void 0 ? _a : '',
        activePlanGroup: (_b = data.activePlanGroup) !== null && _b !== void 0 ? _b : '',
        ownPlanId: (_c = data.ownPlanId) !== null && _c !== void 0 ? _c : '',
        ownPlanGroup: (_d = data.ownPlanGroup) !== null && _d !== void 0 ? _d : '',
        activeTrialInfo: buildTrialInfoOrUndefined(data.activeTrialInfo),
        lastTrialInfo: buildTrialInfoOrUndefined(data.lastTrialInfo),
        email: (_e = data.email) !== null && _e !== void 0 ? _e : '',
        firstName: (_f = data.firstName) !== null && _f !== void 0 ? _f : '',
        lastName: (_g = data.lastName) !== null && _g !== void 0 ? _g : '',
        name: (_h = data.name) !== null && _h !== void 0 ? _h : '',
        uid: (_j = data.uid) !== null && _j !== void 0 ? _j : '',
    };
    return result;
};
export const buildCurrentUserResponseOrEmpty = (data) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (!data) {
        return {
            activePlanId: 'FREE_2016',
            activePlanGroup: 'Free',
            ownPlanId: 'FREE_2016',
            ownPlanGroup: 'Free',
            activeTrialInfo: undefined,
            lastTrialInfo: undefined,
            email: undefined,
            firstName: undefined,
            lastName: undefined,
            name: undefined,
            uid: undefined,
        };
    }
    return {
        activePlanId: (_a = data.activePlanId) !== null && _a !== void 0 ? _a : 'FREE_2016',
        activePlanGroup: (_b = data.activePlanGroup) !== null && _b !== void 0 ? _b : 'Free',
        ownPlanId: (_c = data.ownPlanId) !== null && _c !== void 0 ? _c : 'FREE_2016',
        ownPlanGroup: (_d = data.ownPlanGroup) !== null && _d !== void 0 ? _d : 'Free',
        activeTrialInfo: buildTrialInfoOrUndefined(data.activeTrialInfo),
        lastTrialInfo: buildTrialInfoOrUndefined(data.lastTrialInfo),
        email: (_e = data.email) !== null && _e !== void 0 ? _e : undefined,
        firstName: (_f = data.firstName) !== null && _f !== void 0 ? _f : undefined,
        lastName: (_g = data.lastName) !== null && _g !== void 0 ? _g : undefined,
        name: (_h = data.name) !== null && _h !== void 0 ? _h : undefined,
        uid: (_j = data.uid) !== null && _j !== void 0 ? _j : undefined,
    };
};
